"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORAGE_KEY = exports.COOKIE = exports.ENDPOINT = void 0;
exports.ENDPOINT = '/ns-sd/frontservices/2.0/authentication/webvalidate';
exports.COOKIE = '.ASPXAUTH';
exports.STORAGE_KEY = 'veepeeMember';
